import { modalController } from "@ionic/vue";
import { Storage } from "@ionic/storage";
import RoodieCheckModal from "@/components/RoodieCheckModal";

export const chat = {
  methods: {
    openChat(from) {
      let name = "pain";
      let shouldShowPaintype = false;
      if (
        this.from === "specialist" ||
        (this.from === "" && ["medgate", "betterDoc"].includes(from))
      ) {
        name = "doctorsearch";
      } else if (this.from === "secondopinion") {
        name = "secondopinion";
      } else if (this.from === "dentist" || from === "ztkCard") {
        name = "tooth";
      } else if (from === "betterDoc") {
        name = null;
        shouldShowPaintype = true;
      }
      this.$router.push({
        name: "home",
        params: {
          name: name,
          area: "body-front",
          shouldShowPaintype: shouldShowPaintype,
          from: from,
        },
      });
    },
    async openShowPaintype(callback) {
      const storage = new Storage();
      await storage.create();
      const roodieCheckInfo = await storage.get("roodieCheckInfo");
      if (!roodieCheckInfo) {
        const modal = await modalController.create({
          component: RoodieCheckModal,
          cssClass: "c-autoheight-modal",
        });
        modal.onDidDismiss().then((data) => {
          if (data.data?.continue) {
            storage.set("roodieCheckInfo", true);
            callback();
          }
        });
        modal.present();
      } else {
        callback();
      }
    },
  },
};
